import { FileIconComponent, Tooltip } from "@synthesis/shared-ui";
import { cn } from "@synthesis/shared-utils";

export type AttachmentFileMeta = {
  id: string;
  baseName: string;
  ext?: string | null;
};

type AttachmentFileRowProps = {
  fileMeta: AttachmentFileMeta;
  download: (fileMeta: AttachmentFileMeta) => void | Promise<void>;
};

/** Скачивание файла — по клику на название (Link-стиль из UI-кита, см. макет «Документы»). */
const FILE_NAME_LINK_CLASS = cn(
  "text-system-info-50 w-fit max-w-full cursor-pointer truncate text-left underline decoration-transparent duration-200",
  "hover:decoration-system-info-50",
  "focus-visible:outline-system-info-50",
  "active:text-type-common active:!decoration-type-common",
);

const AttachmentFileRow = ({ fileMeta, download }: AttachmentFileRowProps) => {
  const fileExt = fileMeta.ext ?? "";
  const fileName = fileExt ? `${fileMeta.baseName}.${fileExt}` : fileMeta.baseName;

  return (
    <li className="group min-w-0 max-w-full overflow-hidden">
      <div className="outline-system-info-70 hover:bg-neutrals-95 focus:bg-neutrals-95 group-focus-within:bg-neutrals-95 flex max-w-full items-center gap-3 overflow-x-hidden rounded p-1 transition duration-75">
        <FileIconComponent className="size-6 shrink-0" ext={fileExt} />
        <div className="min-w-0 flex-1 overflow-hidden">
          <Tooltip description={fileName}>
            <button type="button" className={FILE_NAME_LINK_CLASS} onClick={() => void download(fileMeta)}>
              {fileName}
            </button>
          </Tooltip>
        </div>
      </div>
    </li>
  );
};

export { AttachmentFileRow };
